<template></template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue"
import type { AuthAccount } from "../api/auth"
import { vkAuthRoute } from "../api/auth"
import { configureVkId, VKID } from "../shared/vkid"

const props = defineProps<{ sessionId: string }>()
const emit = defineEmits<{ authenticated: [account: AuthAccount, isNewAccount: boolean]; error: [message: string] }>()
let floatingOneTap: VKID.FloatingOneTap | null = null

onMounted(() => {
  try {
    if (!configureVkId()) return
    floatingOneTap = new VKID.FloatingOneTap()
    floatingOneTap
      .on(VKID.WidgetEvents.ERROR, () => emit("error", "Не удалось загрузить быструю авторизацию VK ID"))
      .on(VKID.FloatingOneTapInternalEvents.LOGIN_SUCCESS, async (payload: VKID.AuthResponse) => {
        try {
          const token = await VKID.Auth.exchangeCode(payload.code, payload.device_id)
          const result = await vkAuthRoute.run(ctx, { accessToken: token.access_token, deviceSessionId: props.sessionId })
          floatingOneTap?.close()
          emit("authenticated", result.account, result.isNewAccount)
        } catch {
          emit("error", "Не удалось завершить вход через VK ID")
        }
      })
      .render({
        appName: "Pomesto",
        contentId: VKID.FloatingOneTapContentId.SIGN_IN_TO_SERVICE,
        showAlternativeLogin: true,
        oauthList: [VKID.OAuthName.OK, VKID.OAuthName.MAIL],
        indent: { top: 16, right: 16, bottom: 12 },
      })
  } catch {
    emit("error", "Не удалось загрузить быструю авторизацию VK ID")
  }
})

onBeforeUnmount(() => floatingOneTap?.close())
</script>
